import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { useCompanyTypstExportAvailability, useCompanyTypstPdfDownload } from '~/functions/companyTypstExport';
import { FileFormat, ReviewCompanyPdfSection } from '~/types/types';
import { downloadPdf, downloadZip } from '~/functions/export';
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTypstExport',
  props: {
    ventureId: {
      type: String,
      required: true
    }
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var ventureIdRef = computed(function () {
      return props.ventureId;
    });
    var _useCompanyTypstExpor = useCompanyTypstExportAvailability(ventureIdRef),
      availabilityLoading = _useCompanyTypstExpor.loading,
      hasImpactStrategyModule = _useCompanyTypstExpor.hasImpactStrategyModule,
      hasImpactGoalModule = _useCompanyTypstExpor.hasImpactGoalModule,
      hasEsgModule = _useCompanyTypstExpor.hasEsgModule,
      availability = _useCompanyTypstExpor.availability,
      completedEsgQuestionnaires = _useCompanyTypstExpor.completedEsgQuestionnaires;
    var _useCompanyTypstPdfDo = useCompanyTypstPdfDownload(ventureIdRef),
      exporting = _useCompanyTypstPdfDo.exporting,
      runCompanyTypstExport = _useCompanyTypstPdfDo.runCompanyTypstExport;
    var selectedQuestionnaireId = ref(null);
    watch(completedEsgQuestionnaires, function (current) {
      if (current !== null && current !== void 0 && current.length && selectedQuestionnaireId.value == null) {
        selectedQuestionnaireId.value = current[0].id;
      }
    }, {
      immediate: true
    });
    var selection = ref({
      strategy: false,
      carry: false,
      ghg: false,
      esg: false
    });
    watch([availability, hasImpactStrategyModule, hasImpactGoalModule, hasEsgModule], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        nextAvailability = _ref4[0];
      selection.value = {
        strategy: hasImpactStrategyModule.value ? nextAvailability.strategy : false,
        carry: hasImpactStrategyModule.value ? nextAvailability.carry : false,
        ghg: hasImpactGoalModule.value ? nextAvailability.ghg : false,
        esg: hasEsgModule.value ? nextAvailability.esg : false
      };
    }, {
      immediate: true
    });
    var onStrategyChange = function onStrategyChange(value) {
      if (availability.value.strategy) {
        selection.value.strategy = value;
      }
    };
    var onCarryChange = function onCarryChange(value) {
      if (availability.value.carry) {
        selection.value.carry = value;
      }
    };
    var onGhgChange = function onGhgChange(value) {
      if (availability.value.ghg) {
        selection.value.ghg = value;
      }
    };
    var onEsgChange = function onEsgChange(value) {
      if (availability.value.esg) {
        selection.value.esg = value;
      }
    };
    var hasSelectedExports = computed(function () {
      return selection.value.strategy || selection.value.carry || selection.value.ghg || selection.value.esg && selectedQuestionnaireId.value != null;
    });
    var triggerTypstExport = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var exportSections, includeEsg, data, file;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (hasSelectedExports.value) {
                _context.next = 3;
                break;
              }
              window.$nuxt.$emit('userError', {
                message: proxy.$t('errorNoSelection')
              });
              return _context.abrupt("return");
            case 3:
              exportSections = [];
              if (selection.value.strategy) exportSections.push(ReviewCompanyPdfSection.Strategy);
              if (selection.value.carry) exportSections.push(ReviewCompanyPdfSection.Carry);
              if (selection.value.ghg) exportSections.push(ReviewCompanyPdfSection.Ghg);
              includeEsg = selection.value.esg && selectedQuestionnaireId.value != null;
              _context.prev = 8;
              _context.next = 11;
              return runCompanyTypstExport({
                input: _objectSpread({
                  ventureId: props.ventureId,
                  sections: exportSections
                }, includeEsg ? {
                  questionnaireId: selectedQuestionnaireId.value
                } : {})
              });
            case 11:
              data = _context.sent;
              file = data === null || data === void 0 ? void 0 : data.exportCompanyTypstPdf;
              if (!(!(file !== null && file !== void 0 && file.base64String) || !file.fileName)) {
                _context.next = 15;
                break;
              }
              throw new Error('Missing export payload');
            case 15:
              if (file.format === FileFormat.Zip) {
                downloadZip(file.base64String, file.fileName);
              } else {
                downloadPdf(file.base64String, file.fileName);
              }
              emit('close');
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](8);
              console.error('Company Typst export failed', _context.t0);
              window.$nuxt.$emit('userError', {
                message: proxy.$t('errorFailed')
              });
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 19]]);
      }));
      return function triggerTypstExport() {
        return _ref5.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      ventureIdRef: ventureIdRef,
      availabilityLoading: availabilityLoading,
      hasImpactStrategyModule: hasImpactStrategyModule,
      hasImpactGoalModule: hasImpactGoalModule,
      hasEsgModule: hasEsgModule,
      availability: availability,
      completedEsgQuestionnaires: completedEsgQuestionnaires,
      exporting: exporting,
      runCompanyTypstExport: runCompanyTypstExport,
      selectedQuestionnaireId: selectedQuestionnaireId,
      selection: selection,
      onStrategyChange: onStrategyChange,
      onCarryChange: onCarryChange,
      onGhgChange: onGhgChange,
      onEsgChange: onEsgChange,
      hasSelectedExports: hasSelectedExports,
      triggerTypstExport: triggerTypstExport
    };
  }
});